import {Plain} from '../../../../../../shared/model/plain.type.model';
import {EmailRow} from './email-row.model';

/**
 * Réhydrate une section venue d'une source externe, et laisse passer celle qui en est déjà une.
 *
 * Même raison que pour les colonnes (cf. `toEmailColumn`) : toute retouche fabrique un nouveau
 * contenu, et les sections qui n'ont pas bougé doivent le traverser telles quelles.
 */
export const toEmailRow = (row: Plain<EmailRow> | EmailRow): EmailRow =>
    row instanceof EmailRow ? row : new EmailRow(row);
